import { render, staticRenderFns } from "./DeviceCategory.vue?vue&type=template&id=62b2af3b&"
import script from "./DeviceCategory.vue?vue&type=script&lang=ts&"
export * from "./DeviceCategory.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceCategory.vue?vue&type=style&index=0&id=62b2af3b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports